import React, { useState, useEffect, useRef } from 'react';
// import Paper from '@material-ui/core/Paper';
// import { 
//   DataGrid, GridToolbarExport, GridToolbarContainer 
// } from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton, Button } from '@material-ui/core';
import { Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
// import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
//import { makeStyles } from '@mui/styles';
//import { Box, IconButton } from '@mui/system';

import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  GetApp as DownloadIcon
} from '@material-ui/icons';
import {
  firstDateOfMonth,
  getPrevMonthDay,
  getNextMonthDay,
  getYearMonthKor,
  getYearMonth
} from '../calendar';
import { reqTaxInvoice } from './api';
import { Actions, Resources, useHasPermissions } from '../lib/react-admin-loopback';

const useStyles = makeStyles((theme) => ({
  paper: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));

// DataGrid column 설정
const columns = [
  { field: 'id', headerName: 'id', hide: true },
  { field: 'invoiceDate', headerName: '작성일자', width: 100 },
  { field: 'businessRegNo', headerName: '사업자등록번호', width: 120 },
  { field: 'taxRegId', headerName: '종사업장번호', width: 80 },
  { field: 'customerName', headerName: '상호', width: 250 },
  { field: 'ceoName', headerName: '성명', width: 130 },
  { field: 'email', headerName: '이메일', width: 200 },
  { field: 'supplyValue', headerName: '공급가액', width: 100 },
  { field: 'tax', headerName: '세액', width: 100 },
  { field: 'invoiceItemDate', headerName: '일자', width: 40 },  
  { field: 'name', headerName: '비고', width: 250 }, 
];

const CustomerTaxInvoiceList = (props) => {

  const hasPermission = useHasPermissions(
    Resources.CustomerBill,
    Actions.List,
    () => {
      alert('권한이 없습니다.');
      props.history.push('/schedules');
    }
  );

    const classes = useStyles();
    const [firstDate, setFirstDate] = useState(firstDateOfMonth(new Date()));
    const dataRef = useRef({
      receiptData: []
    });
  
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          // load 정산 자료
          setLoading(true);
          const { data } = await reqTaxInvoice(firstDate);
          dataRef.current.receiptData = data;
          console.log(dataRef.current.receiptData);
          setLoading(false);
        } catch (err) {
          setError(err);
          setLoading(false);
          // LATER server logging
          console.error(err);
        }
      };
      fetchData();
    }, [firstDate]);
  
    //이전달
    const handleClickPrev = () => {
      setFirstDate(getPrevMonthDay(firstDate));
    };
  
    // 다음달
    const handleClickNext = () => {
      setFirstDate(getNextMonthDay(firstDate));
    };

    const downloadUrl = `${process.env.REACT_APP_FCS_API_URL}/customer-taxinvoice/download?yearMonth=${getYearMonth(firstDate)}`;
    
    return (
      <div style={{ height: '100%', width: '100%' }}>
        <Paper className={classes.paper}>
          <Box>
            <IconButton aria-label='go to prev' onClick={handleClickPrev}>
              <ChevronLeftIcon />
            </IconButton>
            <span>{getYearMonthKor(firstDate)}</span>
            <IconButton aria-label='go to next' onClick={handleClickNext}>
              <ChevronRightIcon />
            </IconButton>
          </Box>
          <Box>
            <Button
                variant='text'
                startIcon={<DownloadIcon />}
                href={downloadUrl}
            >
                세금계산서 목록 다운로드
            </Button>
          </Box>
        </Paper>
        <br />
        <DataGrid
          rows={dataRef.current.receiptData}
          columns={columns}
          pageSize={30}
          error={error}
          loading={loading}
        />
      </div>
    );
  };
  
  export default CustomerTaxInvoiceList;